import { Button, Card, CardContent, PageHeader } from "@jod/ui";
import { createFileRoute } from "@tanstack/react-router";
import { OwnerDataTable as DataTable } from "../../components/owner-data-table.tsx";
import { useOwnerState, useUpdateRetention } from "../../features/backoffice/queries.ts";

export const Route = createFileRoute("/_app/settings/retention")({ component: RetentionScreen });

function RetentionScreen() {
  const { data } = useOwnerState();
  const update = useUpdateRetention();
  const retention = data?.retention;
  return (
    <div className="space-y-6">
      <PageHeader
        title="Data retention settings"
        subtitle="Read-only/guarded retention windows with PII-minimized audit metadata."
      />
      {retention ? (
        <>
          <Card>
            <CardContent className="grid gap-3 p-5 md:grid-cols-3">
              <p>Audit log: {retention.auditLogDays} days</p>
              <p>Analytics: {retention.analyticsDays} days</p>
              <p>Contact reveal: {retention.contactRevealDays} days</p>
              <Button onClick={() => update.mutate({ analyticsDays: retention.analyticsDays })}>
                Save guarded setting
              </Button>
            </CardContent>
          </Card>
          <DataTable
            rows={data?.auditLog ?? []}
            getRowKey={(row) => row.id}
            columns={[
              { key: "action", header: "Action", cell: (row) => row.action },
              { key: "entity", header: "Entity", cell: (row) => `${row.entity}:${row.entityId}` },
              {
                key: "meta",
                header: "PII-minimized metadata",
                cell: (row) => JSON.stringify(row.metadata),
              },
              { key: "time", header: "Created", cell: (row) => row.createdAt },
            ]}
          />
          <Card>
            <CardContent className="p-5">
              <h2 className="font-display font-semibold">Open questions</h2>
              <ul className="list-disc pl-5 text-sm">
                {retention.openQuestions.map((q) => (
                  <li key={q}>{q}</li>
                ))}
              </ul>
            </CardContent>
          </Card>
        </>
      ) : null}
    </div>
  );
}
